import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { registerSW } from "virtual:pwa-register";
import { OutboxProvider } from "./hooks/useOutbox";
import { oidcConfig } from "./auth";
import { router } from "./router";
import "./styles.css";

const queryClient = new QueryClient();
// Offline-capable shell: precached by the service worker, updated silently on the next launch.
registerSW({ immediate: true });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider
      {...oidcConfig}
      onSigninCallback={(user) => {
        // Return to the page that started the sign-in; drop ?code=&state= from the address bar.
        const to = (user?.state as { returnTo?: string } | undefined)?.returnTo ?? "/";
        window.history.replaceState({}, document.title, to);
      }}
    >
      <QueryClientProvider client={queryClient}>
        <OutboxProvider>
          <RouterProvider router={router} />
        </OutboxProvider>
      </QueryClientProvider>
    </AuthProvider>
  </React.StrictMode>,
);
